const createOrderSubMenu = [
  {
    submenu: "Create Order",
    id: 101,
    path: "/ofp/orders/create"
  },
  {
    submenu: "Log Summary",
    id: 102,
    path: "/ofp/orders/logsummary"
  },
  {
    submenu: "Automated Orders",
    id: 103,
    path: "/ofp/orders/autoLog"
  },
  {
    submenu: "Website",
    id: 116,
    path: "/ofp/orders/webSite"
  },
  {
    submenu: "Switchboard Routing",
    id: 104,
    path: "/ofp/orders/edipurchaseorder"
  },
  //INFO: Removed Baja , Rename url and title as Duplicate orders
  {
    submenu: "Duplicate orders",
    id: 105,
    path: "/ofp/orders/duplicate-orders"
  },
  {
    submenu: "Email",
    id: 106,
    path: "/ofp/orders/emailBodyOrders"
  },
  {
    submenu: "PDF",
    id: 107,
    path: "/ofp/orders/pdfOrders"
  },
  {
    submenu: "PO Invoice",
    id: 108,
    path: "/ofp/orders/purchaseOrderInvoice"
  },
  {
    submenu: "PO Creation",
    id: 109,
    path: "/ofp/orders/purchaseOrderCreation"
  },
  {
    submenu: "SO Picking",
    id: 110,
    path: "/ofp/orders/salesOrdersPicking"
  },
  {
    submenu: "Excel",
    id: 111,
    path: "/ofp/orders/excelorders"
  },
  {
    submenu: "Phone",
    id: 112,
    path: "/ofp/orders/phoneorders"
  },
  {
    submenu: "API",
    id: 113,
    path: "/ofp/orders/apiorders"
  },
  {
    submenu: "Specright",
    id: 114,
    path: "/ofp/orders/specright"
  },
  {
    submenu: "Duplicated Orders Summary",
    id: 115,
    path: "/ofp/orders/duplicate-orders-summary"
  }
];

const administrationSubMenu = [
  {
    submenu: "Function Setup",
    id: 201,
    path: "/ofp/administration/function"
  },
  {
    submenu: "ItemXref",
    id: 202,
    path: "/ofp/administration/itemXref"
  },
  {
    submenu: "ShipToXref",
    id: 203,
    path: "/ofp/administration/shipToxref"
  },
  {
    submenu: "Entity",
    id: 204,
    path: "/ofp/administration/entitySearch"
  },
  {
    submenu: "Region Mappings",
    id: 205,
    path: "/ofp/administration/regionMappings"
  },
  {
    submenu: "Currency Conversion",
    id: 206,
    path: "/ofp/administration/currencyconversion"
  },
    {
    submenu: "Staging Configs",
    id: 207,
    path: "/ofp/administration/order-flow"
  },
  {
    submenu: "Item/Store Xref",
    id: 208,
    path: "/ofp/administration/ItemOrStoreDetails"
  }
];

const userManagementSubMenu = [
  {
    submenu: "Users",
    id: 301,
    path: "/ofp/UserManagement/Users"
  }
];
const invoicesSubMenu = [
  {
    submenu: "Credit Invoices",
    id: 401,
    path: "/ofp/invoices/credit-invoices",
    icon: "CreateCreditInvoicesImage"
  }
];

export const sidemenu = (
  showAutoLog,
  showSwitchboardWalmartOrders,
  showSwitchboardSamsClubOrders,
  showSwitchboardTraderJoesOrders,
  showItemXref,
  ShowShipToXref,
  showEntity,
  showUsers,
  showWalmartRegionMappings,
  showSamsClubRegionMappings,
  showTraderJoesRegionMappings,
  showBajaOrders,
  showEmailOrders,
  showPdfOrders,
  showCurrencyConversion,
  showExcelOrders,
  showApiOrders,
  showPhoneOrders,
  showSpecright,
  showPOInvoice,
  showPOCreate,
  showSOPick,
  // TODO: Add new param for credit invoice flag
  //showCreditInvoice
  //TODO:Add new param for duplicate order flag
  //showDuplicateOrders
  showDuplicateOrdersSummary,
  // TODO: use showWebSiteOrders params
  //showWebSiteOrders
  showOrderConfig,
  showItemOrStoreDetails,
) => {
  let filteredSubMenu = [...createOrderSubMenu];
  let filteredAdministrationSubMenu = [...administrationSubMenu];
  let filteredUserManagementSubMenu = [...userManagementSubMenu];
  let filteredInvoicesSubMenu = [...invoicesSubMenu];
  if (!showAutoLog) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 103);
  }

  if (!showSwitchboardWalmartOrders && !showSwitchboardSamsClubOrders && !showSwitchboardTraderJoesOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 104);
  }
  //Info : false flag will help in showing menu item on left nav bar
  //TODO: use enableDuplicateOrders falg remove showBajaOrders flag and hardcoded value
  if (false) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 105);
  }
  //Info : false flag will help in showing menu item on left nav bar
  //TODO: use enableDuplicateOrders falg remove showDuplicateOrdersSummary flag and hardcoded value
  if (!showDuplicateOrdersSummary) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 115);
  }
  // TODO: use showSevenElevenOrders params
  //TODO: remove hard-coded boolen value
    if (false) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 116);
  }

  if (!showEmailOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 106);
  }

  if (!showPdfOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 107);
  }

  if (!showPOInvoice) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 108);
  }

  if (!showPOCreate) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 109);
  }

  if (!showSOPick) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 110);
  }

  if (!showExcelOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 111);
  }

  if (!showPhoneOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 112);
  }

  if (!showApiOrders) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 113);
  }

  if (!showSpecright) {
    filteredSubMenu = filteredSubMenu.filter((item) => item?.id !== 114);
  }
  //TODO: use showCreditInvoice param
  //TODO: remove hard-coded boolen value
  if (false) {
    filteredInvoicesSubMenu = filteredInvoicesSubMenu.filter(
      (item) => item?.id !== 401
    );
  }

  if (!showItemXref) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item?.id !== 202
    );
  }
  if (!ShowShipToXref) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item?.id !== 203
    );
  }
  if (!showEntity) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item?.id !== 204
    );
  }
  if (
    !showWalmartRegionMappings &&
    !showSamsClubRegionMappings &&
    !showTraderJoesRegionMappings
  ) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item?.id !== 205
    );
  }
  if (!showCurrencyConversion) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item?.id !== 206
    );
  }

    if (!showOrderConfig) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item?.id !== 207
    );
  }
  
  if (!showItemOrStoreDetails) {
    filteredAdministrationSubMenu = filteredAdministrationSubMenu.filter(
      (item) => item?.id !== 208
    );
  }


  if (!showUsers) {
    filteredUserManagementSubMenu = filteredUserManagementSubMenu.filter(
      (item) => item?.id !== 301
    );
  }
  const menu = [
    {
      heading: "Orders",
      id: 1,
      icon: "Orders",
      path: "/ofp/orders",
      routePath: "/ofp/orders",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredSubMenu
    },
    {
      heading: "Administration",
      id: 2,
      icon: "admin",
      path: "/ofp/administration/function",
      routePath: "/ofp/administration/function",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredAdministrationSubMenu
    },
    {
      heading: "User Management",
      id: 3,
      icon: "admin",
      path: "/ofp/UserManagement",
      routePath: "/ofp/UserManagement",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredUserManagementSubMenu
    },
    {
      heading: "Invoices",
      id: 4,
      icon: "Invoices",
      path: "/ofp/invoices",
      routePath: "/ofp/invoices",
      isExpanded: true,
      showSubMenuFlag: false,
      menuItems: filteredInvoicesSubMenu
    }
  ];

  return menu;
};
